<template>
  <div id="report-confirmor-list-item" v-if="confirmor">
    <vs-row>
      <vs-col
        vs-type="flex"
        vs-align="center"
        vs-justify="flex-start"
        vs-w="9"
      >
          <vs-avatar
            class="mt-2"
            :src="avatar"
            :text="avatarText"
            size="42px"
            style="cursor:default"
          />
          <p class="confirmor-name-text">{{ confirmor.name }}</p>
      </vs-col>
      <vs-col vs-type="flex" vs-align="center" vs-w="3">
        <div class="ml-auto">
          <vs-chip class="confirmor-status-chip mt-1" :color="chipColor">
            <span>{{ status }}</span>
          </vs-chip>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";

export default {
  name: "CardVesselReportConfirmorListItem",
  props: {
    confirmor: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      avatarText: "",
      avatar: null
    };
  },
  watch: {
    confirmor: {
      immediate: true,
      handler: function() {
        this.setAvatar();
      }
    }
  },
  computed: {
    status() {
      return this.confirmor.confirm_at !== null ? "確認済" : "未確認";
    },
    chipColor: function() {
      return this.confirmor.confirm_at !== null ? "success" : "danger";
    }
  },
  methods: {
    setAvatar() {
      if (this.confirmor.pictures.length !== 0) {
        storage
          .child(this.confirmor.pictures[0].thumbnail_path)
          .getDownloadURL()
          .then(response => {
            this.avatar = response;
          });
      } else {
        this.avatarText = this.confirmor.name.charAt(0);
      }
    }
  }
};
</script>

<style lang="scss">
#report-confirmor-list-item {
  .con-img > img {
    object-fit: cover;
  }
}
</style>
